/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleQuestionEmpty: {
  name: 'circle-question-empty';
  data: string;
} = {
  name: 'circle-question-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm12 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3-8a2 2 0 1 1 2.655 1.89C11.924 12.145 11 12.848 11 14v1a1 1 0 1 0 2 0v-.997a.177.177 0 0 1 .037-.054.674.674 0 0 1 .272-.168A4.001 4.001 0 0 0 12 6a4 4 0 0 0-4 4 1 1 0 1 0 2 0Zm3 4.007v-.004.004Z" fill="currentColor"/></svg>`,
};
